import React, { CSSProperties } from "react";
import { VelavuSite } from "velavu-js-api";
import SelectableCard from "../../elements/selectable-card";
import StatusIndicator from "../../elements/status-indicator";
import { useGeocoder } from "../../helper/api-helper";
import * as styles from "./site-switcher-list-item.module.scss";

interface SiteListItemProps {
	style?: CSSProperties;
	className?: string;

	site: VelavuSite;
	onClick?: VoidFunction;
}

export default function SiteSwitcherListItem(props: SiteListItemProps) {
	const location = useGeocoder(props.site.coordinates);

	const status = props.site.online ? "active" : "inactive";

	return (
		<SelectableCard
			style={props.style}
			className={`${styles.container} ${props.className ?? ""}`}
			onClick={props.onClick}
		>
			<StatusIndicator className={styles.status} status={status} />
			<div className={styles.text}>
				<span className={styles.title}>{props.site.name}</span>
				<span className={styles.subtitle}>{location}</span>
			</div>
		</SelectableCard>
	);
}
